import { ExpandableBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/expandableBlock/expandableBlock.layout'
import { StyleguideExample, StyleguidePart } from '@shared/Hoppinger.Styleguide/Frontend'
import { useSGPrintMode } from '@shared/Hoppinger.Styleguide/Frontend/utils/hooks'
import * as React from 'react'
import { dummyData, randomCaption, randomTitle, randomWords, randomWysiwygText } from '../../../config/dummyData'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentsExpandableBlock = () => (
  <>
    <StyleguidePart title="Default" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentExpandableBlock />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentExpandableBlock = () => {
  useSGPrintMode()
  return (
    <ExpandableBlockLayout
      id="expandable-block-example"
      title={randomTitle()}
      intro={dummyData.intro}
      isPrintMode={false}
      acceptVideoCookie={() => {}}
      videoCookieAccepted={true}
      items={[
        {
          title: randomTitle(),
          body: randomWysiwygText(),
          nestedBlocks: [
            {
              kind: 'nestedQuoteBlock',
              text: dummyData.quote,
              author: randomCaption()
            }
          ]
        },
        {
          title: randomTitle(),
          body: randomWysiwygText(),
          nestedBlocks: [
            {
              kind: 'nestedQuoteBlock',
              text: dummyData.quote,
              author: randomCaption(),
              authorDescription: randomWords()
            },
            {
              kind: 'nestedTextBlock',
              body: randomWysiwygText()
            },
            {
              kind: 'nestedDownloadBlock',
              title: randomTitle(),
              intro: dummyData.intro,
              items: [
                {
                  title: randomTitle(),
                  url: '#'
                },
                {
                  title: randomTitle(),
                  url: '#'
                },
                {
                  title: randomTitle(),
                  url: '#'
                }
              ]
            }
          ]
        },
        {
          title: randomTitle(),
          description: randomTitle(),
          body: randomWysiwygText(),
          nestedBlocks: [
            {
              kind: 'nestedOfficeBlock',
              title: 'Offices',
              intro: dummyData.intro,
              body: dummyData.wysiwygShort,
              address: {
                title: 'Head Office',
                visiting: {
                  address: 'Dummy Address',
                  street: 'Dummy Street 123',
                  code: '12345',
                  city: 'Dummy City',
                  country: 'Dummy Country',
                  mapLink: { ...dummyData.primaryUpdater, title: 'How to get there?' }
                },
                postal: {
                  address: 'Dummy Postal Address',
                  street: 'Dummy Postal Street',
                  code: '54321',
                  city: 'Dummy Postal City',
                  country: 'Dummy Postal Country'
                }
              },
              contact: {
                title: 'Contact Us',
                email: ['dummy@example.com', 'example2@example.com'],
                telephone: ['123-456-7890', '098-765-4321'],
                fax: ['123-456-7890'],
                website: dummyData.primaryUpdater
              }
            },
            {
              kind: 'nestedTextBlock',
              body: randomWysiwygText()
            }
          ]
        }
      ]}
      primaryUpdater={dummyData.primaryUpdater}
    />
  )
}
